import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateOrganizationLetterheadsMutation, UpdateOrganizationLetterheadsMutationVariables } from '@/graphql/generated/graphql';
import { UpdateOrganizationLetterheadsDocument } from '@/graphql/generated/graphql';
export type OrganizationLetterheadUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  FileUrl?: string
  FileKey?: string
  FileName?: string
  FileType?: string
  PageWidth?: number
  PageHeight?: number
  ContentAreaX?: number
  ContentAreaY?: number
  ContentAreaWidth?: number
  ContentAreaHeight?: number
  IsDefault?: boolean
  Name?: string
}

export type UpdateOrganizationLetterheadResponse = {
  data: {
    updateOrganizationLetterheads: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateOrganizationLetterhead = () => {
  const mutation = useMutation({
    mutationKey: ['update-organization-letterhead'],
    mutationFn: (variables: OrganizationLetterheadUpdateInput) => {
      return graphqlClient.request<UpdateOrganizationLetterheadsMutation>(UpdateOrganizationLetterheadsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateOrganizationLetterhead: mutation.mutate,
    updateOrganizationLetterheadAsync: mutation.mutateAsync,
  }
}

export const UPDATE_ORGANIZATION_LETTERHEAD_MUTATION = UpdateOrganizationLetterheadsDocument;
